/* @flow */

export const getProximaLinha = (linha: ?Element): ?HTMLTableRowElement => {
    if (!(linha instanceof HTMLTableRowElement)) {
        return null;
    }

    const tableBody = linha.parentElement;
    if (!(tableBody instanceof HTMLTableSectionElement)) {
        return null;
    }

    return tableBody.rows[linha.rowIndex];
};

export const getLinhaAnterior = (linha: ?Element): ?HTMLTableRowElement => {
    if (!(linha instanceof HTMLTableRowElement)) {
        return null;
    }

    const tableBody = linha.parentElement;
    if (!(tableBody instanceof HTMLTableSectionElement)) {
        return null;
    }

    return tableBody.rows[linha.rowIndex - 2];
};

export const focarLinha = (linha: ?HTMLElement) => linha && linha.focus();
